import { render, staticRenderFns } from "./track.vue?vue&type=template&id=58299808&scoped=true"
import script from "./track.vue?vue&type=script&lang=js"
export * from "./track.vue?vue&type=script&lang=js"
import style0 from "./track.vue?vue&type=style&index=0&id=58299808&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58299808",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58299808')) {
      api.createRecord('58299808', component.options)
    } else {
      api.reload('58299808', component.options)
    }
    module.hot.accept("./track.vue?vue&type=template&id=58299808&scoped=true", function () {
      api.rerender('58299808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bulkyExpress/largeOrderManagement/component/track.vue"
export default component.exports